function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "few-clouds"
}, React.createElement("g", {
  id: "sun"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("g", {
  id: "Group_2"
}, React.createElement("path", {
  id: "Vector",
  d: "M13 22V25",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_3"
}, React.createElement("path", {
  id: "Vector_2",
  d: "M6.63605 19.364L4.51473 21.4853",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_4"
}, React.createElement("path", {
  id: "Vector_3",
  d: "M4 13H1",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_5"
}, React.createElement("path", {
  id: "Vector_4",
  d: "M6.63605 6.63604L4.51473 4.51472",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_6"
}, React.createElement("path", {
  id: "Vector_5",
  d: "M13 4V1",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_7"
}, React.createElement("path", {
  id: "Vector_6",
  d: "M19.364 6.63604L21.4853 4.51472",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_8"
}, React.createElement("path", {
  id: "Vector_7",
  d: "M22 13H25",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
})), React.createElement("g", {
  id: "Group_9"
}, React.createElement("path", {
  id: "Vector_8",
  d: "M19.364 19.364L21.4853 21.4853",
  stroke: "#FFA500",
  strokeWidth: 2,
  strokeLinecap: "round"
}))), React.createElement("path", {
  id: "Vector_9",
  d: "M13 18C15.7614 18 18 15.7614 18 13C18 10.2386 15.7614 8 13 8C10.2386 8 8 10.2386 8 13C8 15.7614 10.2386 18 13 18Z",
  fill: "#FFA500",
  stroke: "#FFA500",
  strokeWidth: 2
})), React.createElement("g", {
  id: "cloud"
}, React.createElement("path", {
  id: "Vector_10",
  d: "M40.7 21.4C40.7 16.8 37 13.2 32.5 13.2C31.5 13.2 30.6 13.4 29.7 13.7C29.4 10.3 26.6 7.5 23.1 7.5C19.4 7.5 16.4 10.5 16.4 14.2C16.4 15 16.6 15.8 16.8 16.5C16.5 16.4 16.1 16.4 15.8 16.4C12.1 16.4 9.10001 19.4 9.10001 23.1C9.10001 26.7 12 29.7 15.6 29.8H32.8C37.2 29.3 40.7 25.8 40.7 21.4Z",
  fill: "#57A0EE",
  stroke: "white",
  strokeWidth: 1.2,
  strokeLinejoin: "round"
})));

var SvgFewClouds = function SvgFewClouds(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFewClouds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/few-clouds.6f39e18d.svg";
export { ForwardRef as ReactComponent };